import {
    GET_MODULES,
    GET_MODULES_ERROR,
    GET_MODULES_LOADING,
    GET_TAGS,
    GET_TAGS_ERROR,
    GET_TAGS_LOADING
} from "../actions/actionTypes";

const initialState = {
    tags :{
        loading : false ,
        error : null ,
        data : []
    },
    modules : {
        loading : false ,
        error: null ,
        data : []
    }

}

export default function multiSelectReducer (state = initialState, action) {
    switch(action.type){
        case GET_TAGS_LOADING :
            return {
                ...state ,
                tags : {
                    ...state.tags ,
                    loading : true ,
                    error : null
                }
            }
        case GET_TAGS :
            return {
                ...state ,
                tags : {
                    ...state.tags ,
                    loading : false ,
                    error : null ,
                    data : action.payload
                }
            }
        case GET_TAGS_ERROR:
            return {
                ...state ,
                tags : {
                    ...state.tags ,
                    loading : false,
                    error : action.payload
                }
            }
        case GET_MODULES_LOADING :
            return {
                ...state ,
                modules : {
                    ...state.modules ,
                    loading : true ,
                    error : null
                }
            }
        case GET_MODULES :
            return {
                ...state ,
                modules : {
                    ...state.modules ,
                    loading : false ,
                    error : null ,
                    data : action.payload
                }
            }
        case GET_MODULES_ERROR:
            return {
                ...state ,
                modules : {
                    ...state.modules ,
                    loading : false,
                    error : action.payload
                }
            }
        default: return state
    }
}

